import { render, staticRenderFns } from "./icon-svg.vue?vue&type=template&id=4c24d6b6&scoped=true&"
import script from "./icon-svg.vue?vue&type=script&lang=js&"
export * from "./icon-svg.vue?vue&type=script&lang=js&"
import style0 from "./icon-svg.vue?vue&type=style&index=0&id=4c24d6b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c24d6b6",
  null
  
)

export default component.exports